{% block sw_cms_element_manufacturer_preview %}
    <div class="sw-cms-element-manufacturer-preview">
        <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--small"></div>
        <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--big sw-cms-element-manufacturer-preview__placeholder--one-fifth"></div>
        <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--big sw-cms-element-manufacturer-preview__placeholder--one-third"></div>

        <div class="sw-cms-element-manufacturer-preview__box-wrapper">
            <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--box"></div>
            <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--box"></div>
            <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--box"></div>
        </div>

        <div class="sw-cms-element-manufacturer-preview__placeholder sw-cms-element-manufacturer-preview__placeholder--big"></div>
    </div>
{% endblock %}